import getUniqueId from 'app/utils/getUniqueId'
import {
    Column,
} from 'app/types/simpletable.types'
import ChipCheckMark from 'app/Apps/DomainObject/ComponentMapper/ChipCheckMark'
import {
    Location,
} from '../Locations.types'

export type LocationDuplication = Pick<Location, 'locationName' | 'addressLine1' | 'archived'> & {
    companyName: string
}

const columns = ({
    label,
    classes,
}): Column<keyof LocationDuplication>[] => {
    return [
        {
            fieldName: 'locationName',
            label: label('Location.locationName'),
            id: getUniqueId(),
        },
        {
            fieldName: 'addressLine1',
            label: label('Location.addressLine1'),
            className: classes.addressLine1,
            id: getUniqueId(),
        },
        {
            fieldName: 'companyName',
            label: label('Location.company'),
            id: getUniqueId(),
        },
        {
            fieldName: 'archived',
            label: label('Location.isArchived'),
            id: getUniqueId(),
            className: classes.archived,
            component: ChipCheckMark,
            getProps: ({
                archived,
            }) => {
                return {
                    value: archived,
                }
            },
        },
    ]
}

export default columns
